import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// The design system's faces, self-hosted through @fontsource (no font CDN: a
// blocked webfont must never delay a shopper's text). Foundation's stacks name
// "Inter" and "IBM Plex Sans Arabic" literally, so the same names here mean no
// splice is needed. The riyal glyph face is served from /public/fonts.
import "@fontsource/ibm-plex-sans-arabic/arabic-400.css";
import "@fontsource/ibm-plex-sans-arabic/arabic-500.css";
import "@fontsource/ibm-plex-sans-arabic/arabic-600.css";
import "@fontsource/ibm-plex-sans-arabic/arabic-700.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import "./index.css";

import { App } from "./shopper/App";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("#root is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
